import styled from 'styled-components';
import { breakpoints, css } from '../../styles/theme';
import CarGalleryTemplate from './CarGalleryTemplate';
import { rem } from 'polished';

export const CarGalleryStyled = styled(CarGalleryTemplate)`
    position: relative;

    &.is-loading {
        opacity: 0.7;
    }

    .react-multi-carousel {
        &-list {
        }

        &-dot-list {
            margin-bottom: ${rem(20)};
        }

        &-dot {
            button {
                border: none;
                border-width: 0;
                margin: 0 ${rem(8)};
                background-color: ${({ theme }) => theme.colors.grey4};
            }
        }

        &-dot--active {
            button {
                background-color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .car-item-wrapper {
        margin-bottom: ${rem(25)};
    }

    .image-wrapper {
        display: flex;
        flex-wrap: wrap;
        height: 45vw;
        justify-content: center;
        align-items: center;
        background-position: center;
        background-repeat: no-repeat;
        transition: background 0.5s;
        z-index: 9;
        margin: ${rem(48)} auto 0 auto;
        background-size: cover;

        @media (min-width: ${breakpoints.sm}px) {
            height: 35vw;
        }

        @media (min-width: ${breakpoints.md}px) {
            margin: 5%;
        }

        img {
            width: 100%;
        }
    }

    .react-multi-carousel-dot-list {
        width: fit-content;
        margin: auto auto 1.25rem;
    }

    .button-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 25px;
        display: flex;
        justify-content: center;
        margin-bottom: ${rem(30)};

        button {
            text-transform: none;
            width: auto;
            background: none !important;
            border: none;
            padding: 0;

            text-decoration: none;
            color: ${({ theme }) => theme.colors.grey1};
            cursor: pointer;
            text-transform: lowercase;
            ::first-letter {
                text-transform: uppercase;
            }

            &.active {
                color: ${({ theme }) => theme.colors.primary};
                cursor: default;
            }

            &:first-child {
                margin-right: ${rem(20)};
            }
        }
    }
`;
